import { BaseRequestModel } from '../../base/base.request.model';

export class UpdateProfileRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  UpdateProfileRequestMessage!: UpdateProfileRequestModel;
}

class UpdateProfileRequestModel extends BaseRequestModel {
  firstName?: string;
  lastName?: string;
  dateOfBirth?: number;
  cpCustomerID?: string;
  email?: string;
  mobileNumber?: string;
  gender?: string;
  addressMsg?: AddressMsg[];
  //acknowledgeSubCancelRemainder!: boolean;
  //acknowledgeSubCancelRemainderDate!: number;
}

export class UpdateProfileRequest {
  contactID: string;
  isSetPSLanguageOnAllProfiles?: boolean;
  contactAdditionalDetails?: {
    primarySpeakingLanguage: string;
  };
}
class AddressMsg {
  address1?: string;
  address2?: string;
  city?: number;
  state?: string;
  country?: string;
  zipCode?: string;
}
